import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-content-body',
  templateUrl: './content-body.component.html',
  styleUrls: ['./content-body.component.scss']
})
export class ContentBodyComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
